/* eslint no-multi-spaces: 0 */
/* eslint key-spacing: 0 */

import Vue from 'vue'
import {store} from '@/components/store'
import UserModel from './map.json'

const User = {
  loginUrl : 'about:blank',
  email    : ''
}

var sessionCheckTimer = null

function logout() {
  var app = global.app

  localStorage.removeItem('evedUser')
  localStorage.removeItem('evedUserCsrf')
  app.$router.push({name: 'login'})
  app.$store.state.isLoggedIn = false
  app.$store.state.csrf = null
  app.$user.email = null
  app.$user.$ = null
  store.commit('updateSessionValidity', false)
  app.$notifications.removeAll()

  app.api.get(app.api.$.Logout)
  app.api.get(app.api.$.logout)

  clearInterval(sessionCheckTimer)
  sessionCheckTimer = null
}

function login(credentials) {
  var app = global.app

  return new Promise((resolve, reject) => {
    app.api.post(app.api.$.login, credentials, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })
  })
}

/**
 * Bind authentication endpoint response to $user
 *
 * @desc Response object {r}
 * @property {string} sk                  - user token
 * @property {object} user                - user details
 * @property {string} username            - user email
 * @property {Array.<string>} permissions - user permissions
 * @property {Object.<Object>} modules    - user modules
 * @property {string} type                - user type
 * @property {string} subscription        - user subcription
 * @property {(string)number} domain      - user market type id: 1=buyer, 2=buyer/seller, 3=seller
 *
 * @property {string} error               - authentication error
 */
function init(r, user) {
  this.$ = {}

  Object.keys(UserModel).forEach(key => {
    this.$[key] = user[key] = r ? r[UserModel[key]] : user[key]
  })

  store.dispatch('check')
  store.dispatch('ping')
}

export default {
  $: {
    get() { return User },
    default: User
  },

  get: ()  => JSON.parse(global.localStorage.getItem('evedUser')),
  set: (v) => global.localStorage.setItem('evedUser', JSON.stringify(v)),

  init() {
    /** Setup user on Vue instance */
    Object.defineProperty(Vue.prototype, '$user', {
      get() {
        var user    = this.$root.getUser

        user.logout = logout
        user.login  = login
        user.init   = function (response, authUser) { init.call(user, response, authUser) }

        return user
      }
    })

    /** Init user with stored user */
    const authUser = JSON.parse(global.localStorage.getItem('evedUser'))

    if (authUser && authUser.token) {
      init.call(User, null, authUser)

      /** Once set up, start verifying session validity */
      // store.dispatch('ping')
    }
  },

  /**
   * Check session validity on the `ping` api endpoint
   * at a configured interval and only if tab is active
   */
  checkSession(commit) {
    const api = global.app.api

    if (commit === true) {
      ping(true)
      if (store.state.isLoggedIn) {
        window.document.onmouseenter = () => ping(true)
      }
    } else {
      if (store.state.isLoggedIn) {
        sessionCheckTimer = setInterval(() => { if (!document.hidden) ping(commit) }, 1000 * 60)
      }
    }

    function ping (commit) {
      if (store.state.isLoggedIn || commit === true) {
        api.get(api.$.ping).then((res) => {
          if (res) {
            if (commit !== true) {
              commit('updateSessionValidity', res.data)
            } else {
              store.commit('updateSessionValidity', res.data)
            }
          }
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/user/index.js